import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function ResolvedIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7,
    fill: "currentColor"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "m13 8-4 4-2-2",
    stroke: "var(--lb-icon-background)"
  }));
}

export { ResolvedIcon };
//# sourceMappingURL=Resolved.mjs.map
